module.exports = __webpack_public_path__ + "static/media/team-stephanie.06dc3ba1.png";